import React from 'react';
import HolidaysTableContent from './table/HolidaysTableContent';
import HolidaysTableHeader from './table/HolidaysTableHeader';
import type { Holiday } from '../../../types';

type Props = {
  holidays: Array<Holiday>,
  onEditModalOpen: (holiday: Holiday) => void,
  onAddModalOpen: () => void,
  onFetchHolidaysFromApi: () => void,
};

const HolidaysContent = (props: Props) => {
  const {
    holidays,
    onEditModalOpen,
    onAddModalOpen,
    onFetchHolidaysFromApi,
  } = props;

  return (
    <>
      <HolidaysTableHeader
        onFetchHolidaysFromApi={onFetchHolidaysFromApi}
      />
      <HolidaysTableContent
        holidays={holidays}
        onEditModalOpen={onEditModalOpen}
        onAddModalOpen={onAddModalOpen}
      />
    </>
  );
};

export default HolidaysContent;
